import { faAndroid } from '@fortawesome/free-brands-svg-icons/faAndroid';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faChrome } from '@fortawesome/free-brands-svg-icons/faChrome';
import { faFirefoxBrowser } from '@fortawesome/free-brands-svg-icons/faFirefoxBrowser';
import { faInternetExplorer } from '@fortawesome/free-brands-svg-icons/faInternetExplorer';
import { faLinux } from '@fortawesome/free-brands-svg-icons/faLinux';
import { faOpera } from '@fortawesome/free-brands-svg-icons/faOpera';
import { faQq } from '@fortawesome/free-brands-svg-icons/faQq';
import { faSafari } from '@fortawesome/free-brands-svg-icons/faSafari';
import { faWindows } from '@fortawesome/free-brands-svg-icons/faWindows';
import { faYandex } from '@fortawesome/free-brands-svg-icons/faYandex';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { faComputer } from '@fortawesome/pro-solid-svg-icons/faComputer';
import { faDesktop } from '@fortawesome/pro-solid-svg-icons/faDesktop';
import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt';
import { faTablet } from '@fortawesome/pro-solid-svg-icons/faTablet';
import { faUserSecret } from '@fortawesome/pro-solid-svg-icons/faUserSecret';
import { UAParser } from 'ua-parser-js';

const UserDevice = (userAgent: string, userAgentData?: any) => {
	const parser = userAgentData ? null : new UAParser(userAgent);
	const device = parser?.getDevice().model ? parser.getDevice().model : undefined;
	/*
	`${currentUserAgent.getDevice().vendor ? `${currentUserAgent.getDevice().vendor} ${currentUserAgent.getDevice().model ? currentUserAgent.getDevice().model : ''} - ` : ''}${currentUserAgent.getBrowser().name} ${currentUserAgent.getBrowser().version} - ${currentUserAgent.getOS().name} ${currentUserAgent.getOS().version}
*/

	return userAgentData && userAgentData.brands.length > 0
		? `${userAgentData.model ? `${userAgentData.model} - ` : ''}${userAgentData.brands[0] ? `${userAgentData.brands[0].brand} ${userAgentData.brands[0].version} - ` : ''} ${userAgentData.platform ? userAgentData.platform : ''} ${userAgentData.platformVersion ? userAgentData.platformVersion : ''}`
		: userAgentData
			? 'Supported, but no details returned'
			: `${device ? `${device} - ` : ''}${parser?.getBrowser().name} ${parser?.getBrowser().version} - ${parser?.getOS().name} ${parser?.getOS().version}`;
};

const SystemIcon = (userAgent: string, userAgentData?: any): IconDefinition => {
	const parser = userAgentData ? null : new UAParser(userAgent);
	const system = userAgentData ? userAgentData.platform : parser?.getOS().name;

	// AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki, Fedora,
	// Firefox OS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS, Joli, Linpus, Linux,
	// Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD, Nintendo, OpenBSD, OpenVMS,
	// OS/2, Palm, PCLinuxOS, Plan9, Playstation, QNX, RedHat, RIM Tablet OS, RISC OS, Sailfish,
	// Series40, Slackware, Solaris, SUSE, Symbian, Tizen, Ubuntu, UNIX, VectorLinux, WebOS,
	// Windows [Phone/Mobile], Zenwalk

	if (system === 'Windows' || system === 'Windows Phone OS') {
		return faWindows;
	}
	if (system === 'Mac OS' || system === 'iOS') {
		return faApple;
	}
	if (system === 'Linux') {
		return faLinux;
	}
	if (system === 'Android') {
		return faAndroid;
	}
	if (system === 'Chromium OS') {
		return faChrome;
	}

	return faUserSecret;
};

const BrowserIcon = (userAgent: string, userAgentData?: any): IconDefinition => {
	const parser = userAgentData ? null : new UAParser(userAgent);
	const name =
		userAgentData && userAgentData.brands.length > 0 ? userAgentData.brands[0].brand : parser?.getBrowser().name;

	// Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Camino, Chimera, Chrome, Chromium,
	// Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge, Epiphany, Fennec, Firebird, Firefox,
	// Flock, GoBrowser, iCab, ICE Browser, IceApe, IceCat, IceDragon, Iceweasel, IE [Mobile], Iron,
	// Jasmine, K-Meleon, Konqueror, Kindle, Links, Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo,
	// MIUI Browser, [Mobile] Safari, Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb,
	// Opera [Mini/Mobi/Tablet], Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey,
	// SlimBrowser, Swiftfox, Tizen, UCBrowser, Vivaldi, w3m, Yandex

	if (name === 'Firefox') {
		return faFirefoxBrowser;
	}
	if (name === 'IE') {
		return faInternetExplorer;
	}
	if (name === 'Edge') {
		return faInternetExplorer;
	}
	if (name === 'Safari' || name === 'Mobile Safari') {
		return faSafari;
	}
	if (name === 'Yandex') {
		return faYandex;
	}
	if (name === 'Chrome' || name === 'Google Chrome' || name === 'Chromium') {
		return faChrome;
	}
	if (name === 'QQBrowser') {
		return faQq;
	}
	if (name && name.indexOf('Opera') > -1) {
		return faOpera;
	}

	return faUserSecret;
};

const DeviceType = (userAgent: string, userAgentData?: any): IconDefinition => {
	if (userAgentData) {
		return userAgentData.isMobile ? faMobileAlt : faComputer;
	}
	const parser = new UAParser(userAgent);
	const type = parser.getDevice().type;

	// Amaya, Android Browser, Arora, Avant, Baidu, Blazer, Bolt, Camino, Chimera, Chrome, Chromium,
	// Comodo Dragon, Conkeror, Dillo, Dolphin, Doris, Edge, Epiphany, Fennec, Firebird, Firefox,
	// Flock, GoBrowser, iCab, ICE Browser, IceApe, IceCat, IceDragon, Iceweasel, IE [Mobile], Iron,
	// Jasmine, K-Meleon, Konqueror, Kindle, Links, Lunascape, Lynx, Maemo, Maxthon, Midori, Minimo,
	// MIUI Browser, [Mobile] Safari, Mosaic, Mozilla, Netfront, Netscape, NetSurf, Nokia, OmniWeb,
	// Opera [Mini/Mobi/Tablet], Phoenix, Polaris, QQBrowser, RockMelt, Silk, Skyfire, SeaMonkey,
	// SlimBrowser, Swiftfox, Tizen, UCBrowser, Vivaldi, w3m, Yandex

	if (type === 'mobile') {
		return faMobileAlt;
	}
	if (type === 'tablet') {
		return faTablet;
	}
	return faDesktop;
};

export { UserDevice, DeviceType, SystemIcon, BrowserIcon };
